namespace TabAurous.ECommerce {
    export namespace OrderStatusService {
        export const baseUrl = 'ECommerce/OrderStatus';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ECommOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ECommerce/OrderStatus/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OrderStatusService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
